<template>
    <div>
        <v-list-item class="justify-center">
            <v-list-item-avatar size="160" color="brown darken-4">
                <slot name="avatarImage"></slot>
            </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
            <v-list-item-content>
                <slot name="userName">
                <v-list-item-title class="text-h6"> {{ userName }} </v-list-item-title>
                </slot>
                
                <slot name="email">
                <v-list-item-subtitle> {{ email }} </v-list-item-subtitle>
                </slot>
            </v-list-item-content>
            <v-list-item-action>
                <v-icon>mdi-menu-down</v-icon>
            </v-list-item-action>
        </v-list-item>
    </div>
</template>

<script>
export default {
    name: 'Avatar'
}
</script>
